import styled from "styled-components";

export const StyledApp = styled.div``;

export const StyledTracking = styled.div`
  padding: 10px 20px 96px;
  min-height: 100vh;
  background: var(--rms-v2-section-bg);
  box-sizing: border-box;

  .tracking-page-intro {
    margin-bottom: 16px;
  }

  .tracking-meta {
    display: flex;
    flex-wrap: wrap;
    gap: 8px;
    margin-top: 1rem;
    font-size: 12px;
    color: var(--rms-v2-text-muted);
  }

  .tracking-meta span {
    background: var(--rms-v2-surface);
    border: 1px solid var(--rms-v2-border-soft);
    border-radius: 999px;
    padding: 4px 8px;
  }

  .tracking-card {
    background: var(--rms-v2-surface);
    border-radius: ${(props) => (props.rounded ? "14px" : "0px")};
    box-shadow: 0 8px 24px rgba(16, 24, 40, 0.05);
    padding: 16px;
  }

  .tracking-alert-banner {
    margin-bottom: 16px;
  }

  .tracking-alert-banner.warning {
    background: var(--rms-v2-warning-soft, #fff7de);
    border: 1px solid
      color-mix(
        in srgb,
        var(--rms-v2-warning, #946200) 28%,
        var(--rms-v2-warning-soft, #fff7de)
      );
  }

  .tracking-alert-banner.danger {
    background: var(--rms-v2-danger-soft);
    border: 1px solid
      color-mix(
        in srgb,
        var(--rms-v2-danger) 28%,
        var(--rms-v2-danger-soft)
      );
  }

  .tracking-alert-banner.info {
    background: var(--rms-v2-primary-faint);
    border: 1px solid var(--rms-v2-primary-soft);
  }

  .tracking-alert-title {
    align-items: center;
    display: flex;
    gap: 4px;
    margin-bottom: 6px;
  }

  .tracking-alert-title svg {
    font-size: 14px;
    flex: 0 0 auto;
  }

  .tracking-alert-title p {
    font-size: 12px;
    font-weight: 900;
    margin: 0;
  }

  .tracking-alert-banner.warning .tracking-alert-title,
  .tracking-alert-banner.warning .tracking-alert-title p,
  .tracking-alert-banner.warning .tracking-alert-title svg {
    color: var(--rms-v2-warning, #946200);
  }

  .tracking-alert-banner.danger .tracking-alert-title,
  .tracking-alert-banner.danger .tracking-alert-title p,
  .tracking-alert-banner.danger .tracking-alert-title svg {
    color: var(--rms-v2-danger);
  }

  .tracking-alert-banner.info .tracking-alert-title,
  .tracking-alert-banner.info .tracking-alert-title p,
  .tracking-alert-banner.info .tracking-alert-title svg {
    color: ${(props) => props.primaryColor};
  }

  .tracking-alert-banner span {
    color: var(--rms-v2-text-body);
    display: block;
    font-size: 11px;
    line-height: 1.45;
  }

  .tracking-alert-link {
    appearance: none;
    background: transparent;
    border: 0;
    color: ${(props) => props.primaryColor};
    cursor: pointer;
    font: inherit;
    font-size: 12px;
    font-weight: 800;
    padding: 0;
    text-decoration: underline;
  }

  .tracking-section-title {
    color: var(--rms-v2-text-title);
    font-size: 14px;
    font-weight: 800;
    margin: 0 0 14px;
    text-transform: none;
  }

  .tracking-card-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 12px;
    margin-bottom: 12px;
  }

  .tracking-card-header .tracking-section-title {
    margin: 0;
  }

  .tracking-journey-card {
    margin-bottom: 1rem;
  }

  .tracking-card-header span {
    color: var(--rms-v2-text-muted);
    font-size: 11px;
    font-weight: 700;
    text-transform: uppercase;
  }

  .tracking-journey-card .MuiStepper-root {
    margin: 0;
  }

  .tracking-journey-card .MuiStepLabel-label,
  .tracking-journey-card .step-label {
    color: var(--rms-v2-text-body);
    font-size: 12px;
    font-weight: 600;
  }

  .tracking-journey-card .MuiStepLabel-label.Mui-active {
    color: ${(props) => props.primaryColor};
    font-weight: 800;
  }

  .tracking-submit-shipment,
  .tracking-submit-button {
    align-items: center !important;
    background: ${(props) => props.primaryColor} !important;
    color: var(--rms-v2-surface) !important;
    border-radius: ${(props) => (props.rounded ? "999px" : "0px")} !important;
    display: inline-flex !important;
    gap: 8px !important;
    justify-content: center !important;
    text-transform: none !important;
    box-shadow: none !important;
    font-size: 12px !important;
    font-weight: 800 !important;
  }

  .tracking-submit-shipment {
    margin-top: 10px !important;
  }

  .tracking-details-submitted {
    align-items: flex-start;
    border: 1px solid var(--rms-v2-success-soft);
    display: flex;
    gap: 10px;
  }

  .tracking-details-submitted > svg {
    color: var(--rms-v2-success);
    flex: 0 0 auto;
    font-size: 20px;
    margin-top: 1px;
  }

  .tracking-details-submitted p {
    color: var(--rms-v2-text-title);
    font-size: 13px;
    font-weight: 900;
    margin: 0 0 4px;
  }

  .tracking-details-submitted span {
    color: var(--rms-v2-text-body);
    display: block;
    font-size: 12px;
    line-height: 1.45;
  }

  .tracking-details-message {
    border-radius: ${(props) => (props.rounded ? "10px" : "0px")};
    font-size: 12px;
    font-weight: 700;
    line-height: 1.4;
    padding: 10px 12px;
  }

  .tracking-details-message.error {
    background: var(--rms-v2-danger-soft);
    color: var(--rms-v2-danger);
  }

  .tracking-content {
    display: flex;
    flex-direction: column;
    gap: 16px;
  }

  .tracking-content .products-return,
  .tracking-content .price-details {
    width: 100%;
  }

  .tracking-content .products-return {
    display: flex;
    flex-direction: column;
    gap: 16px;
  }

  .tracking-content .price-details {
    padding: 0;
    gap: 16px;
  }

  .tracking-content .price-details > .exchange-payment-group {
    order: 2;
  }

  .tracking-content .price-details > .exchange-details-group,
  .tracking-content .price-details > .refund-details-group {
    order: 3;
    background: var(--rms-v2-surface);
    border-radius: ${(props) => (props.rounded ? "14px" : "0px")};
    box-shadow: 0 8px 24px rgba(16, 24, 40, 0.05);
    margin: 0 !important;
    overflow: hidden;
    padding: 16px;
  }

  .tracking-content .price-details > .refund-details-group {
    order: 4;
  }

  .tracking-content .price-details > .box,
  .tracking-line-items-card {
    background: var(--rms-v2-surface);
    border-radius: ${(props) => (props.rounded ? "14px" : "0px")};
    box-shadow: 0 8px 24px rgba(16, 24, 40, 0.05);
    margin: 0 !important;
    overflow: hidden;
    padding: 16px;
  }

  .tracking-content .price-details > .box:not(.exchange-payment-group):not(.exchange-details-group):not(.refund-details-group) {
    order: 5;
  }

  .tracking-content .price-details > .tracking-card {
    order: 6;
  }

  .tracking-line-items-section {
    display: flex;
    flex-direction: column;
    gap: 10px;
  }

  .tracking-line-items-section > .product-details {
    color: var(--rms-v2-text-title);
    font-size: 16px;
    font-weight: 800;
    margin: 0 0 2px;
  }

  .tracking-line-item-box {
    box-sizing: border-box;
    margin-bottom: 0;
    max-width: 100%;
    min-width: 0;
    position: relative;
    width: 100%;
  }

  .tracking-request-type-tag {
    align-items: center;
    background: var(--rms-v2-primary-faint);
    border-radius: 0 ${(props) => (props.rounded ? "14px" : "0px")} 0
      ${(props) => (props.rounded ? "10px" : "0px")};
    color: ${(props) => props.primaryColor};
    box-sizing: border-box;
    display: block;
    font-size: 11px;
    font-weight: 800;
    line-height: 1.2;
    max-width: calc(100% - 16px);
    overflow: hidden;
    overflow-wrap: anywhere;
    padding: 7px 10px;
    position: absolute;
    right: 0;
    text-align: center;
    top: 0;
    white-space: normal;
    width: 96px;
    word-break: break-word;
    z-index: 3;
  }

  .tracking-line-items-card .product-details,
  .tracking-content .price-details > .box .title,
  .tracking-content .price-details > .exchange-details-group .title,
  .tracking-content .price-details > .refund-details-group .title {
    color: var(--rms-v2-text-title) !important;
    font-size: 14px !important;
    font-weight: 800 !important;
    margin: 0 0 14px !important;
  }

  .tracking-line-items-list {
    display: flex;
    flex-direction: column;
    gap: 12px;
    max-width: 100%;
    min-width: 0;
    overflow: hidden;
    width: 100%;
  }

  .tracking-line-items-card .line-item-card {
    background: transparent !important;
    border: 0 !important;
    box-shadow: none !important;
    margin: 0 !important;
    padding: 0 !important;
  }

  .tracking-line-items-card .line-item-card-main {
    grid-template-columns: 64px 1fr;
  }

  .tracking-line-items-card .line-item-title {
    padding-right: 100px;
    white-space: normal;
    max-width: 100%;
  }

  .tracking-line-item-reason {
    color: var(--rms-v2-text-body) !important;
    font-size: 12px !important;
    margin: 12px 0 0 !important;
  }

  .tracking-line-item-status {
    align-items: flex-start;
    background: var(--rms-v2-primary-faint);
    border: 1px solid var(--rms-v2-primary-soft);
    border-radius: ${(props) => (props.rounded ? "10px" : "0px")};
    display: flex;
    justify-content: space-between;
    gap: 12px;
    margin-top: 12px;
    padding: 9px 10px;
  }

  .tracking-inline-timeline {
    margin-top: 12px;
    padding: 0;
  }

  .tracking-line-items-card .line-item-price-row,
  .tracking-line-items-card .line-item-price,
  .tracking-line-items-card .line-item-price-stack,
  .tracking-line-items-card .line-item-current-price,
  .tracking-line-items-card .line-item-compare-price {
    max-width: 100%;
    min-width: 0;
  }

  .tracking-line-items-card .line-item-price {
    overflow-wrap: anywhere;
    white-space: normal;
    word-break: break-word;
  }

  .tracking-line-items-card .line-item-current-price,
  .tracking-line-items-card .line-item-compare-price {
    overflow-wrap: anywhere;
  }

  .tracking-inline-current-label {
    color: ${(props) => props.primaryColor};
    display: block;
    font-size: 12px;
    font-weight: 900;
    margin-top: 8px;
    max-width: 100%;
    overflow-wrap: anywhere;
    text-align: center;
    text-wrap: auto;
    white-space: normal;
  }

  .tracking-inline-timeline-dots {
    display: grid;
    gap: 0;
    grid-auto-flow: column;
    grid-auto-columns: minmax(28px, 1fr);
    overflow-x: auto;
    padding-top: 10px;
    margin-top: 14px;
    position: relative;
  }

  .customer-inspection { margin-top: 16px; border-top: 1px solid var(--rms-v2-border); padding-top: 12px; }
  .customer-inspection summary { cursor: pointer; font-weight: 600; font-size: 13px; line-height: 1.5; }
  .customer-inspection summary:focus-visible { outline: 2px solid currentColor; outline-offset: 3px; }
  .customer-inspection ul { list-style: none; padding: 0; margin: 8px 0 0; }
  .customer-inspection li { display: flex; justify-content: space-between; gap: 12px; padding: 8px 0; line-height: 1.5; border-bottom: 1px solid var(--rms-v2-border); }
  .customer-inspection li > div { min-width: 0; overflow-wrap: anywhere; }
  .customer-inspection li strong { font-size: 12px; font-weight: 600; display: block; }
  .customer-inspection li span { font-size: 11px; display: block; color: var(--rms-v2-text-muted); margin-top: 2px; }
  .customer-inspection-amount { text-align: right; flex-shrink: 0; font-variant-numeric: tabular-nums; }

  .tracking-inline-timeline-step {
    align-items: center;
    display: flex;
    flex-direction: column;
    min-height: 36px;
    position: relative;
  }

  .tracking-inline-timeline-step:not(:first-child)::before {
    background: var(--rms-v2-border);
    content: "";
    height: 2px;
    left: calc(-50% + 7px);
    position: absolute;
    right: calc(50% + 7px);
    top: 7px;
  }

  .tracking-inline-timeline-step.completed:not(:first-child)::before,
  .tracking-inline-timeline-step.current:not(:first-child)::before {
    background: ${(props) => props.primaryColor};
  }

  .tracking-inline-timeline-dot {
    background: var(--rms-v2-border);
    border-radius: 50%;
    display: block;
    height: 14px;
    position: relative;
    width: 14px;
    z-index: 1;
  }

  .tracking-inline-timeline-step.completed .tracking-inline-timeline-dot,
  .tracking-inline-timeline-step.current .tracking-inline-timeline-dot {
    background: ${(props) => props.primaryColor};
    box-shadow: 0 0 0 4px var(--rms-v2-primary-faint);
  }

  .tracking-inline-timeline-step.final-completed .tracking-inline-timeline-dot {
    background: var(--rms-v2-success);
    box-shadow: 0 0 0 4px var(--rms-v2-success-soft);
  }

  .tracking-inline-timeline-step.final-completed .tracking-inline-timeline-dot::before {
    color: var(--rms-v2-surface);
    content: "✓";
    font-size: 10px;
    font-weight: 900;
    left: 50%;
    line-height: 1;
    position: absolute;
    top: 50%;
    transform: translate(-50%, -50%);
  }

  .tracking-inline-timeline-step.current .tracking-inline-timeline-dot::after {
    animation: trackingCurrentPulse 1.5s ease-out infinite;
    border: 2px solid ${(props) => props.primaryColor};
    border-radius: 50%;
    content: "";
    inset: -6px;
    opacity: 0.45;
    position: absolute;
  }

  .tracking-inline-timeline-step.final-completed.current .tracking-inline-timeline-dot::after {
    border-color: var(--rms-v2-success);
  }

  @keyframes trackingCurrentPulse {
    from {
      opacity: 0.5;
      transform: scale(0.75);
    }
    to {
      opacity: 0;
      transform: scale(1.55);
    }
  }

  .tracking-line-item-status > div {
    min-width: 0;
  }

  .tracking-line-item-status span {
    color: var(--rms-v2-text-muted);
    display: block;
    font-size: 11px;
    font-weight: 800;
    text-transform: uppercase;
  }

  .tracking-line-item-status strong {
    color: ${(props) => props.primaryColor};
    display: block;
    font-size: 12px;
    font-weight: 900;
    margin-top: 4px;
    text-align: right;
  }

  .tracking-line-item-status.rejected {
    background: var(--rms-v2-danger-soft);
    border-color: var(--rms-v2-danger-soft);
  }

  .tracking-line-item-status.rejected strong {
    color: var(--rms-v2-danger);
  }

  .tracking-line-item-rejected-reason {
    color: var(--rms-v2-danger) !important;
    font-size: 12px !important;
    font-weight: 700 !important;
    margin: 10px 0 0 !important;
  }

  .pickup-proof-section,
  .return-qc-upload-section {
    border-top: 1px solid var(--rms-v2-border-soft);
    display: grid;
    gap: 10px;
    margin-top: 14px;
    padding-top: 14px;
  }

  .pickup-proof-header p,
  .return-qc-upload-header p {
    color: var(--rms-v2-text-title);
    font-size: 13px;
    font-weight: 900;
    margin: 0 0 3px;
  }

  .pickup-proof-header span,
  .return-qc-upload-header span {
    color: var(--rms-v2-text-muted);
    display: block;
    font-size: 12px;
    line-height: 1.4;
  }

  .return-qc-missing-checks {
    display: flex;
    flex-wrap: wrap;
    gap: 6px;
  }

  .return-qc-missing-checks span {
    background: var(--rms-v2-warning-soft, #fff7de);
    border: 1px solid
      color-mix(
        in srgb,
        var(--rms-v2-warning, #946200) 24%,
        var(--rms-v2-warning-soft, #fff7de)
      );
    border-radius: ${(props) => (props.rounded ? "999px" : "0px")};
    color: var(--rms-v2-warning, #946200);
    font-size: 10px;
    font-weight: 800;
    line-height: 1.2;
    padding: 5px 8px;
  }

  .return-qc-guidance-list {
    color: var(--rms-v2-text-body);
    display: grid;
    font-size: 11px;
    gap: 4px;
    line-height: 1.45;
    margin: 0;
    padding-left: 18px;
  }

  .pickup-proof-add-tile,
  .return-qc-add-tile {
    align-items: center;
    background: var(--rms-v2-primary-faint);
    border: 1px dashed ${(props) => props.primaryColor};
    border-radius: ${(props) => (props.rounded ? "10px" : "0px")};
    color: ${(props) => props.primaryColor};
    cursor: pointer;
    display: inline-flex;
    flex: 0 0 auto;
    flex-direction: column;
    font-size: 11px;
    font-weight: 800;
    gap: 6px;
    height: 84px;
    justify-content: center;
    width: 84px;
  }

  .pickup-proof-add-tile svg,
  .return-qc-add-tile svg {
    height: 24px;
    width: 24px;
  }

  .pickup-proof-submit,
  .return-qc-submit {
    width: 100%;
  }

  .pickup-proof-success,
  .return-qc-upload-success {
    align-items: flex-start;
    background: var(--rms-v2-success-soft);
    border: 1px solid var(--rms-v2-success-soft);
    border-radius: ${(props) => (props.rounded ? "12px" : "0px")};
    display: flex;
    gap: 10px;
    padding: 12px;
  }

  .pickup-proof-success > svg,
  .return-qc-upload-success > svg {
    color: var(--rms-v2-success);
    flex: 0 0 auto;
    font-size: 20px;
    margin-top: 1px;
  }

  .pickup-proof-success p,
  .return-qc-upload-success p {
    color: var(--rms-v2-text-title);
    font-size: 13px;
    font-weight: 900;
    margin: 0 0 4px;
  }

  .pickup-proof-success span,
  .return-qc-upload-success span {
    color: var(--rms-v2-text-body);
    display: block;
    font-size: 12px;
    line-height: 1.45;
  }

  .tracking-timeline-actions {
    align-items: center;
    display: flex;
    flex-wrap: wrap;
    gap: 10px;
    margin-top: 10px;
    width: 100%;
  }

  .tracking-timeline-actions.has-status .tracking-view-timeline {
    margin-left: auto;
  }

  .tracking-warranty-status {
    color: var(--rms-v2-text-body);
    font-size: 10px;
    font-weight: 800;
    overflow-wrap: anywhere;
  }

  .tracking-view-timeline {
    border: 0;
    background: transparent;
    color: ${(props) => props.primaryColor};
    cursor: pointer;
    display: block;
    font-size: 10px;
    font-weight: 800;
    margin: 0;
    padding: 0;
    white-space: nowrap;
  }

  .shipment-line-items-card .shipment-accordion {
    box-shadow: none !important;
    margin: 0 !important;
  }

  .shipment-line-items-card .shipment-accordion + .shipment-accordion {
    border-top: 1px solid var(--rms-v2-border-soft);
    margin-top: 12px !important;
    padding-top: 12px;
  }

  .tracking-content .price-details > .box .return-detail-card {
    background: transparent;
    border-radius: 0;
    box-shadow: none;
    margin: 0;
    padding: 0;
  }

  .tracking-content .price-details > .exchange-payment-group .exchange-payment-detail-card {
    border: 0;
    border-radius: 0;
    box-shadow: none;
    margin: 0;
    padding: 0;
  }

  .tracking-content .price-details > .exchange-payment-group .exchange-payment-detail-card .MuiButton-root {
    margin: 12px 0 0;
  }

  .tracking-content .price-details > .exchange-details-group .return-detail-card,
  .tracking-content .price-details > .refund-details-group .return-detail-card {
    background: transparent;
    border: 0;
    border-radius: 0;
    box-shadow: none;
    margin: 0;
    padding: 0;
  }

  .tracking-content .price-details > .exchange-details-group .exchange-order-link {
    align-items: center;
    color: ${(props) => props.primaryColor};
    display: inline-flex;
    gap: 4px;
    font-size: 13px;
    font-weight: 900;
    text-decoration: none;
  }

  .tracking-content .price-details > .exchange-details-group .exchange-order-link svg {
    height: 13px;
    width: 13px;
  }

  .tracking-content .price-details > .box .return-detail-card + .return-detail-card,
  .tracking-content .price-details > .box .return-detail-item + .return-detail-item,
  .tracking-content .price-details > .refund-details-group .return-detail-item + .return-detail-item,
  .exchange-payment-group > div + div {
    border-top: 1px solid var(--rms-v2-border-soft);
    margin-top: 14px;
    padding-top: 14px;
  }

  .tracking-content .price-details > .box .return-detail-item,
  .tracking-content .price-details > .refund-details-group .return-detail-item {
    margin: 0;
  }

  .tracking-content .price-details .tracking-address-card .v2-resolution-note-title {
    margin: 0 0 8px;
    color: var(--rms-v2-text-title);
    font-size: 13px;
    font-weight: 800;
  }

  .tracking-detail-label {
    color: var(--rms-v2-text-muted);
    font-size: 10px;
    font-weight: 800;
    letter-spacing: 0.6px;
    margin: 12px 0 6px;
    text-transform: uppercase;
  }

  .tracking-detail-value,
  .tracking-address-text,
  .tracking-address-card p {
    color: var(--rms-v2-text-body);
    font-size: 13px;
    line-height: 1.5;
    margin: 0;
  }

  .customer-preference-card {
    margin: 0;
  }

  .customer-preference-grid,
  .payment-reference-grid {
    display: grid;
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 14px;
  }

  .customer-preference-grid .tracking-detail-label,
  .payment-reference-grid .tracking-detail-label {
    margin-top: 0;
  }

  .customer-preference-wide {
    grid-column: 1 / -1;
  }

  .payment-reference-grid {
    border-top: 1px solid var(--rms-v2-border-soft);
    margin-top: 12px;
    padding-top: 12px;
  }

  .payment-reference-grid .tracking-detail-value {
    overflow-wrap: anywhere;
  }

  .pickup-details-card .pickup-address-row {
    margin-top: 0;
  }

  .tracking-address-actions {
    align-items: center;
    display: flex;
    flex-wrap: wrap;
    gap: 10px;
    justify-content: flex-end;
  }

  .tracking-copy-address {
    align-items: center;
    border: 0;
    background: transparent;
    color: ${(props) => props.primaryColor};
    cursor: pointer;
    display: inline-flex;
    font-size: 11px;
    font-weight: 800;
    gap: 4px;
    padding: 0;
    white-space: nowrap;
  }

  .tracking-copy-address svg {
    height: 14px;
    width: 14px;
  }

  .tracking-copy-address.copied {
    color: var(--rms-v2-success);
  }

  .tracking-copy-success-icon {
    color: var(--rms-v2-success);
  }

  .self-ship-steps {
    display: flex;
    flex-direction: column;
    gap: 10px;
  }

  .self-ship-steps div {
    background: var(--rms-v2-section-bg);
    border-radius: ${(props) => (props.rounded ? "14px" : "0px")};
    color: var(--rms-v2-text-body);
    display: flex;
    align-items: center;
    flex-direction: column;
    gap: 8px;
    font-size: 12px;
    font-weight: 700;
    padding: 18px;
    text-align: center;
  }

  .self-ship-step-icon {
    align-items: center;
    background: var(--rms-v2-primary-faint);
    border-radius: 999px;
    color: ${(props) => props.primaryColor};
    display: inline-flex;
    height: 38px;
    justify-content: center;
    width: 38px;
  }

  .self-ship-step-icon svg {
    height: 18px;
    width: 18px;
  }

  .shipping-details-card form {
    display: flex;
    flex-direction: column;
    gap: 14px;
  }

  .shipping-details-card {
    scroll-margin-top: 88px;
  }

  .tracking-details-header-actions {
    align-items: center;
    display: flex;
    gap: 10px;
  }

  .tracking-how-to-ship-button {
    align-items: center;
    background: transparent;
    border: 0;
    color: ${(props) => props.primaryColor};
    cursor: pointer;
    display: inline-flex;
    font-size: 11px;
    font-weight: 800;
    gap: 4px;
    padding: 0;
    white-space: nowrap;
  }

  .tracking-how-to-ship-button svg {
    height: 15px;
    width: 15px;
  }

  .shipping-details-address {
    border: 1px solid var(--rms-v2-border-soft);
    border-radius: ${(props) => (props.rounded ? "12px" : "0px")};
    margin-bottom: 14px;
    padding: 12px;
  }

  .shipping-details-address-header {
    align-items: center;
    display: flex;
    gap: 10px;
    justify-content: space-between;
    margin-bottom: 8px;
  }

  .shipping-details-address-header .tracking-detail-label {
    margin: 0;
  }

  .shipping-details-address-value {
    align-items: flex-start;
    display: grid;
    gap: 8px;
    grid-template-columns: 18px 1fr;
  }

  .shipping-details-address-value svg {
    color: ${(props) => props.primaryColor};
    height: 18px;
    margin-top: 1px;
    width: 18px;
  }

  .shipping-details-address-value p {
    color: var(--rms-v2-text-body);
    font-size: 13px;
    line-height: 1.45;
    margin: 0;
  }

  .shipping-details-card label {
    display: flex;
    flex-direction: column;
    gap: 6px;
  }

  .shipping-details-card label span,
  .receipt-upload p {
    color: var(--rms-v2-text-muted);
    font-size: 12px;
    font-weight: 700;
    margin: 0;
  }

  .shipping-details-card input {
    border: 1px solid var(--rms-v2-border-soft);
    border-radius: ${(props) => (props.rounded ? "12px" : "0px")};
    box-sizing: border-box;
    color: var(--rms-v2-text-body);
    font-size: 13px;
    min-height: 42px;
    padding: 0 12px;
    width: 100%;
  }

  .shipping-details-card input:disabled {
    background: var(--rms-v2-section-bg);
    color: var(--rms-v2-text-muted);
  }

  .receipt-upload {
    display: flex;
    flex-direction: column;
    gap: 10px;
  }

  .media-upload-input,
  .receipt-upload input[type="file"] {
    display: none;
  }

  .media-upload-preview-list {
    display: flex;
    align-items: flex-start;
    gap: 10px;
    flex-wrap: wrap;
  }

  .media-preview-tile {
    position: relative;
    width: 84px;
    height: 84px;
    border-radius: ${(props) => (props.rounded ? "10px" : "0px")};
    overflow: hidden;
    background: var(--rms-v2-section-bg);
    border: 1px solid var(--rms-v2-border-soft);
    flex: 0 0 auto;
  }

  .media-preview-asset {
    width: 100%;
    height: 100%;
    object-fit: cover;
    display: block;
  }

  .media-preview-file {
    align-items: center;
    color: ${(props) => props.primaryColor};
    display: flex;
    height: 100%;
    justify-content: center;
    width: 100%;
  }

  .media-preview-file svg {
    height: 32px;
    width: 32px;
  }

  .receipt-file-details {
    align-self: center;
    display: grid;
    gap: 3px;
    min-width: 0;
  }

  .receipt-file-details p {
    color: var(--rms-v2-text-title) !important;
    font-size: 12px !important;
    font-weight: 800 !important;
    margin: 0 !important;
    overflow-wrap: anywhere;
  }

  .receipt-file-details span {
    color: var(--rms-v2-text-muted);
    font-size: 11px;
    font-weight: 600;
  }

  .media-preview-remove {
    position: absolute;
    top: 2px;
    right: 2px;
    width: 26px;
    height: 26px;
    border-radius: 999px;
    border: 1px solid rgba(255, 255, 255, 0.88);
    background: rgba(17, 24, 39, 0.86);
    display: inline-flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    padding: 0;
    z-index: 2;
  }

  .media-preview-remove svg {
    width: 13px;
    height: 13px;
    color: #fff;
  }

  .media-preview-remove svg path {
    stroke: #fff;
  }

  .media-upload-dropzone,
  .receipt-upload-button {
    align-items: center;
    border: 1px dashed ${(props) => props.primaryColor};
    border-radius: ${(props) => (props.rounded ? "12px" : "0px")};
    color: ${(props) => props.primaryColor};
    cursor: pointer;
    display: flex;
    gap: 12px;
    padding: 12px;
    min-height: 62px;
    background: var(--rms-v2-primary-faint);
  }

  .media-upload-dropzone-icon {
    align-items: center;
    background: var(--rms-v2-surface);
    border-radius: 999px;
    color: ${(props) => props.primaryColor};
    display: flex;
    flex: 0 0 auto;
    height: 40px;
    justify-content: center;
    width: 40px;
  }

  .media-upload-title {
    color: var(--rms-v2-text-title) !important;
    font-size: 13px !important;
    font-weight: 800 !important;
    margin: 0 !important;
  }

  .media-upload-description {
    color: var(--rms-v2-text-muted) !important;
    font-size: 12px;
    font-weight: 600 !important;
    margin: 2px 0 0 !important;
  }

  .media-upload-counts {
    align-items: center;
    display: inline-flex;
    flex-wrap: wrap;
    gap: 12px;
  }

  .media-upload-count {
    align-items: center;
    color: var(--rms-v2-text-muted);
    display: inline-flex;
    font-size: 12px !important;
    font-weight: 700 !important;
    gap: 5px;
    margin: 0 !important;
  }

  .media-upload-count > svg {
    height: 16px;
    width: 16px;
  }

  .media-upload-success-icon {
    color: var(--rms-v2-success);
  }

  .tracking-details-info {
    background: var(--rms-v2-section-bg);
    border-radius: ${(props) => (props.rounded ? "12px" : "0px")};
    padding: 12px;
  }

  .tracking-details-info p {
    color: var(--rms-v2-text-title);
    font-size: 13px;
    font-weight: 900;
    margin: 0 0 4px;
  }

  .tracking-details-info span {
    color: var(--rms-v2-text-body);
    display: block;
    font-size: 12px;
    line-height: 1.45;
  }

  .shipment-accordion {
    p,
    svg {
      font-size: 14px;
    }

    .description {
      color: #3B444D;
      font-size: 10px;
    }
  }
`;

export const StyledTimelineDrawer = styled.div`
  background: var(--rms-v2-surface);
  color: var(--rms-v2-text-body);
  max-height: 82vh;
  overflow-y: visible;
  padding: 28px 20px 20px;
  position: relative;

  .self-ship-guide-content .tracking-section-title {
    color: var(--rms-v2-text-title);
    font-size: 16px;
    font-weight: 900;
    margin: 0 0 14px;
  }

  .self-ship-steps {
    display: flex;
    flex-direction: column;
    gap: 10px;
  }

  .self-ship-steps div {
    align-items: center;
    background: var(--rms-v2-section-bg);
    border-radius: 14px;
    color: var(--rms-v2-text-body);
    display: flex;
    flex-direction: column;
    font-size: 12px;
    font-weight: 700;
    gap: 8px;
    padding: 18px;
    text-align: center;
  }

  .self-ship-step-icon {
    align-items: center;
    background: var(--rms-v2-primary-faint);
    border-radius: 999px;
    color: ${(props) => props.primaryColor};
    display: inline-flex;
    height: 38px;
    justify-content: center;
    width: 38px;
  }

  .self-ship-step-icon svg {
    height: 18px;
    width: 18px;
  }

  .timeline-drawer-header {
    align-items: flex-start;
    border-bottom: 1px solid var(--rms-v2-border-soft);
    display: flex;
    gap: 12px;
    justify-content: space-between;
    padding-bottom: 16px;
  }

  .timeline-drawer-title {
    color: var(--rms-v2-text-title);
    font-size: 16px;
    font-weight: 900;
    line-height: 1.35;
    margin: 0;
  }

  .timeline-drawer-subtitle {
    color: ${(props) => props.primaryColor};
    font-size: 12px;
    font-weight: 800;
    margin: 6px 0 0;
  }

  .timeline-drawer-info {
    align-items: flex-start;
    background: var(--rms-v2-primary-faint);
    border: 1px solid var(--rms-v2-primary-soft);
    border-radius: 10px;
    display: grid;
    grid-template-columns: 18px 1fr;
    gap: 8px;
    margin-top: 14px;
    padding: 10px;
  }

  .timeline-drawer-info svg {
    color: ${(props) => props.primaryColor};
  }

  .timeline-drawer-info p {
    color: var(--rms-v2-text-muted);
    font-size: 11px;
    font-weight: 600;
    line-height: 1.45;
    margin: 0;
  }

  .timeline-shipment-details {
    border: 1px solid var(--rms-v2-border-soft);
    border-radius: 10px;
    display: grid;
    gap: 10px;
    margin-top: 14px;
    padding: 12px;
  }

  .timeline-shipment-header {
    align-items: center;
    display: flex;
    gap: 10px;
    justify-content: flex-start;
  }

  .timeline-shipment-title {
    color: var(--rms-v2-text-title);
    font-size: 13px;
    font-weight: 900;
    margin: 0;
  }

  .timeline-shipment-grid {
    display: grid;
    gap: 14px;
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  .timeline-shipment-grid div {
    display: grid;
    gap: 4px;
  }

  .timeline-shipment-grid span {
    color: var(--rms-v2-text-muted);
    font-size: 10px;
    font-weight: 800;
    text-transform: uppercase;
  }

  .timeline-shipment-grid strong,
  .timeline-shipment-grid a {
    align-items: center;
    color: var(--rms-v2-text-body);
    display: inline-flex;
    gap: 4px;
    font-size: 12px;
    font-weight: 800;
    overflow-wrap: anywhere;
    text-decoration: none;
  }

  .timeline-shipment-status-pill {
    border-radius: 999px;
    display: inline-flex !important;
    font-size: 10px;
    font-weight: 900;
    justify-self: start;
    line-height: 1;
    padding: 3px 8px;
    text-transform: none;
  }

  .timeline-shipment-status-pill.success {
    background: var(--rms-v2-success-soft);
    color: var(--rms-v2-success);
  }

  .timeline-shipment-status-pill.warning {
    background: var(--rms-v2-warning-soft, #fff7de);
    color: var(--rms-v2-warning, #946200);
  }

  .timeline-shipment-status-pill.danger {
    background: var(--rms-v2-danger-soft);
    color: var(--rms-v2-danger);
  }

  .timeline-shipment-grid a {
    color: ${(props) => props.primaryColor};
  }

  .timeline-shipment-grid a svg {
    height: 13px;
    width: 13px;
  }

  .timeline-drawer-list {
    padding: 18px 0 4px;
  }

  .timeline-drawer-row {
    display: grid;
    grid-template-columns: 20px 1fr;
    gap: 12px;
    min-height: 54px;
    position: relative;
  }

  .timeline-drawer-row:not(:last-child)::after {
    background: var(--rms-v2-border);
    content: "";
    height: calc(100% - 18px);
    left: 8px;
    position: absolute;
    top: 22px;
    width: 2px;
  }

  .timeline-drawer-marker {
    background: var(--rms-v2-border);
    border-radius: 50%;
    display: block;
    height: 18px;
    margin-top: 1px;
    position: relative;
    width: 18px;
    z-index: 1;
  }

  .timeline-drawer-row.completed:not(:last-child)::after {
    background: ${(props) => props.primaryColor};
  }

  .timeline-drawer-row.completed .timeline-drawer-marker {
    background: ${(props) => props.primaryColor};
  }

  .timeline-drawer-row.current .timeline-drawer-marker {
    background: ${(props) => props.primaryColor};
    box-shadow: 0 0 0 4px var(--rms-v2-primary-faint);
  }

  .timeline-drawer-row.current .timeline-drawer-marker::after {
    animation: trackingCurrentPulse 1.5s ease-out infinite;
    border: 2px solid ${(props) => props.primaryColor};
    border-radius: 50%;
    content: "";
    inset: -6px;
    opacity: 0.45;
    position: absolute;
  }

  .timeline-drawer-row.final-completed .timeline-drawer-marker {
    background: var(--rms-v2-success);
    box-shadow: 0 0 0 4px var(--rms-v2-success-soft);
  }

  .timeline-drawer-row.final-completed:not(:last-child)::after {
    background: var(--rms-v2-success);
  }

  .timeline-drawer-row.final-completed .timeline-drawer-marker::before {
    color: var(--rms-v2-surface);
    content: "✓";
    font-size: 12px;
    font-weight: 900;
    left: 50%;
    line-height: 1;
    position: absolute;
    top: 50%;
    transform: translate(-50%, -50%);
  }

  .timeline-drawer-row.final-completed.current .timeline-drawer-marker::after {
    border-color: var(--rms-v2-success);
  }

  .timeline-drawer-row p {
    color: var(--rms-v2-text-muted);
    font-size: 13px;
    font-weight: 800;
    margin: 0;
  }

  .timeline-drawer-row.current p {
    color: ${(props) => props.primaryColor};
    font-weight: 900;
  }

  .timeline-drawer-row span {
    color: var(--rms-v2-text-muted);
    display: block;
    font-size: 11px;
    font-weight: 600;
    margin-top: 4px;
  }
`;
